import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import './EventMap.css';
import "leaflet/dist/leaflet.css";
 
const customIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  shadowSize: [41, 41],
});
 
const bounds = [
  [-85, -180], // Southwest corner
  [85, 180], // Northeast corner
];

const MapComponent = ({ reportsData }) => {
  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      maxZoom={10}
      minZoom={1}
      maxBounds={bounds}
      //maxBoundsViscosity={1.0} // Makes the bounds "hard" (no elastic bounce)
      style={{ height: "85%", width: "100%" }}
    >
      <TileLayer
        url="http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
      />
      {reportsData.map((event, index) => ( ( ((event.latitude !== 0) || (event.longitude !== 0 )) ? (
        <Marker
          key={index}
          position={[event.latitude, event.longitude]}
          icon={customIcon}
        >
          <Popup>
            {event.siteCode} <br /> Latitude: {event.latitude} <br /> Longitude: {event.longitude}
          </Popup>
        </Marker>
      ) : "")))}
    </MapContainer>
  );
};
 
export default MapComponent;